import { getManOfTheMatchRequest } from "../repositories/man_of_the_match_repository";
export const ManOfTheMatchService = () => {
    const fetchManOfTheMatch = async (setManOfTheMatchData) => {
        try {
            const response = await getManOfTheMatchRequest();
            if (response?.success) {
                setManOfTheMatchData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch man of the match data.");
        }
    };
    return {
        fetchManOfTheMatch,
    };
};